import { InvoiceIssuer } from "./invoice-issuer";
import { InvoiceIssuerBank } from "./invoice-issuer-bank";
import { InvoiceLineItem } from "./invoice-line-item";
import { InvoiceReceiver } from "./invoice-receiver";

export class SalesInvoiceWithNewNumber {
    constructor(
        public invoiceNumber: string | null,
        public items: InvoiceLineItem[],
        public issuer: InvoiceIssuer,
        public receiver: InvoiceReceiver,
        public isIssued: boolean,
        public receivingBank: InvoiceIssuerBank,
        public sequenceNumber: number,
        public year: number
    ){}
}